import { type PointerEvent } from 'react'
import { Link } from 'react-router-dom'
import { ArrowIcon, AudioIcon, MultimediaIcon, WebDevelopmentIcon } from './icons'

type HomeServiceCardProps = {
  number: string
  title: string
  text: string
  linkLabel: string
  to: string
  icon: 'web' | 'multimedia' | 'audio'
}

const icons = {
  web: WebDevelopmentIcon,
  multimedia: MultimediaIcon,
  audio: AudioIcon,
}

export default function HomeServiceCard({ number, title, text, linkLabel, to, icon }: HomeServiceCardProps) {
  const Icon = icons[icon]
  const updateSpotlight = (event: PointerEvent<HTMLAnchorElement>) => {
    const bounds = event.currentTarget.getBoundingClientRect()
    event.currentTarget.style.setProperty('--spotlight-x', `${event.clientX - bounds.left}px`)
    event.currentTarget.style.setProperty('--spotlight-y', `${event.clientY - bounds.top}px`)
  }

  return (
    <article className={`home-service-card home-service-card--${icon}`}>
      <Link to={to} aria-label={`${linkLabel}: ${title}`} onPointerMove={updateSpotlight}>
        <div className="home-service-card__top"><Icon className="home-service-card__icon" /><span>{number}</span></div>
        <h3>{title}</h3>
        <p>{text}</p>
        <span className="home-service-card__link">{linkLabel}<ArrowIcon /></span>
      </Link>
    </article>
  )
}
